document.addEventListener('DOMContentLoaded', sendCartPageData);

function sendCartPageData() {
	const cartItems = document.querySelectorAll('.cart__form-item');
	const itemsArray = Array.from(cartItems).map((item) => {
		const eventDetail = item.dataset;
		return formatDataLayerObject('view_cart', eventDetail).ecommerce.items[0];
	});

	if (itemsArray.length > 0) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'view_cart',
			ecommerce: {
				items: itemsArray,
			},
		});
	}
}
